module.exports = __webpack_public_path__ + "img/copper_vip_invalid.14e42c29.png";